module.exports = __webpack_public_path__ + "img/Privacy-Monitor_Logo.ab82f8c1.svg";